export const Fields = {
  TEXT_FIELD: 'textfield',
  SELECT_FIELD: 'selectfield',
  MULTIPLE_SELECT_FIELD: 'multipleSelectfield',
  ADDRESS_FIELD: 'addressField',
  COLOR_PICKER: 'colorPicker',
  PASSWORD_FIELD: 'passwordField',
  CUSTOM: 'custom',
  SEPARATOR: 'separator',
  RADIO: 'radio',
  RADIO_BUTTON: 'radioButton',
  DATE: 'date',
  TOGGLE: 'toggle',
  CUSTOM_CALENDAR_INSTRUCTIONS: 'custom_calendar_instructions',
  CUSTOM_RATIO: 'custom_ratio',
  CUSTOM_QUALIFICATION_PROFESSIONAL_SITUATION: 'custom_qualificationProfessionalSituation',
  CUSTOM_QUALIFICATION_COUPLE: 'custom_qualificationCouple',
  CUSTOM_QUALIFICATION_GUARANTOR_TYPE: 'custom_qualificationGuarantorType',
}
